import { Component } from "@angular/core";

@Component({
  selector: "app-elite-lexus-icon",
  standalone: true,
  template: `
<svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 512 512"
     fill="currentColor">

  <!-- ELITE OF LEXUS -->
  <text x="256"
        y="70"
        text-anchor="middle"
        font-size="50"
        font-family="Arial, Helvetica, sans-serif"
        letter-spacing="8">
    ELITE OF LEXUS
  </text>

  <!-- Top sweep -->
  <path d="M120 160
           C210 95 330 95 405 160
           C330 120 225 120 120 160Z"/>

  <!-- Center sweep -->
  <path d="M95 220
           C215 185 340 190 415 245
           C325 210 220 210 95 220Z"/>

  <!-- Lower sweep -->
  <path d="M90 295
           C220 275 335 280 405 320
           C320 295 215 300 90 295Z"/>

  <!-- Left vertical curve -->
  <path d="M210 130
           C150 210 155 335 235 415
           C180 330 180 220 210 130Z"/>

  <!-- Right vertical curve -->
  <path d="M335 130
           C395 210 395 330 305 420
           C355 325 360 220 335 130Z"/>

  <!-- Right orbit -->
  <path d="M350 150
           C445 230 445 305 350 380
           C400 315 395 235 350 150Z"/>

  <!-- Bottom outer arc -->
  <path d="M25 295
           C90 450 220 510 365 485
           C455 470 505 405 512 305
           C470 410 405 455 320 468
           C180 488 75 435 25 295Z"/>

</svg>
  `,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: inherit;
    }
    svg {
      width: 24px;
      height: 24px;
    }
  `]
})
export class EliteLexusIconComponent {
}
